import { render, staticRenderFns } from "./ComposicaoPreparacao.vue?vue&type=template&id=c1c63d7a&scoped=true&"
import script from "./ComposicaoPreparacao.vue?vue&type=script&lang=js&"
export * from "./ComposicaoPreparacao.vue?vue&type=script&lang=js&"
import style0 from "./ComposicaoPreparacao.vue?vue&type=style&index=0&id=c1c63d7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c63d7a",
  null
  
)

export default component.exports